const PAYMENT_LOGOS = [
  { src: 'https://xt30sf.b-cdn.net/media/53b5d40061396a2f2173c.png', alt: 'Visa' },
  { src: 'https://xt30sf.b-cdn.net/media/45897b0061396a8921f26.png', alt: 'Mastercard' },
  { src: 'https://xt30sf.b-cdn.net/media/6c1f142061396b1b1d924.png', alt: 'Google Pay' },
  { src: 'https://xt30sf.b-cdn.net/media/8e7d5410613965b22e34a.png', alt: 'Apple Pay' },
  { src: 'https://xt30sf.b-cdn.net/media/66e97f20613969d994bb9.png', alt: 'Amopay' },
  { src: 'https://xt30sf.b-cdn.net/media/656a0730613969324beeb.png', alt: 'SpeedPay' },
  { src: 'https://xt30sf.b-cdn.net/media/765dcdef5139686d734a5.png', alt: 'OSKO' },
  { src: 'https://xt30sf.b-cdn.net/media/08c834ef51396bb598c3a.png', alt: 'PayID' },
];

const CERT_LOGOS = [
  { src: 'https://xt30sf.b-cdn.net/media/5dad4f30613963c1d6f0e.png', alt: 'PAGCOR' },
  { src: 'https://xt30sf.b-cdn.net/media/1fbd0940613965ecea80d.png', alt: 'BMM Testlabs' },
  { src: 'https://xt30sf.b-cdn.net/media/fec6515061396fbd3c26b.png', alt: 'ThreatMetrix' },
  { src: 'https://xt30sf.b-cdn.net/media/fe74ac50613962679be2c.png', alt: 'TST Verified' },
  { src: 'https://xt30sf.b-cdn.net/media/25b6a86061396e4313830.png', alt: 'SSL Secure' },
  { src: 'https://xt30sf.b-cdn.net/media/9129bd90613964d26f392.png', alt: 'eCOGRA' },
  { src: 'https://xt30sf.b-cdn.net/media/540e95a061396b51af2fd.png', alt: 'Gambling Therapy' },
  { src: 'https://xt30sf.b-cdn.net/media/f27e25b061396265edc8d.png', alt: '18+' },
];

function LogoRow({ logos }: { logos: { src: string; alt: string }[] }) {
  const doubled = [...logos, ...logos];
  return (
    <div className="overflow-hidden relative">
      <div className="flex items-center marquee-track gap-4">
        {doubled.map((logo, i) => (
          <div
            key={`${logo.alt}-${i}`}
            className="flex-shrink-0 flex items-center justify-center rounded-xl px-5 py-3 transition-all duration-300 hover:scale-105"
            style={{ border: '1px solid rgba(71,202,241,0.15)', background: 'rgba(71,202,241,0.04)' }}
          >
            <img src={logo.src} alt={logo.alt} className="max-h-7 max-w-full object-contain opacity-70 hover:opacity-100 transition-opacity" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PaymentBadgesSection() {
  return (
    <section className="relative py-12 sm:py-14 px-4 sm:px-5 md:px-8 overflow-hidden" style={{ background: '#0d1117' }}>
      <div className="section-divider absolute top-0 left-0 w-full"></div>
      <div className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at 50% 50%, rgba(71,202,241,0.04) 0%, transparent 70%)' }}
      ></div>

      <div className="relative max-w-7xl mx-auto space-y-10">
        <div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-5 sm:mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(71,202,241,0.1)', border: '1px solid rgba(71,202,241,0.2)' }}>
              <i className="ri-wallet-3-line text-[#47CAF1] text-base"></i>
            </div>
            <div>
              <h2 className="text-lg sm:text-xl font-bold text-white">Available Payment Methods</h2>
              <div className="glow-line w-24 mt-1"></div>
            </div>
          </div>
          <LogoRow logos={PAYMENT_LOGOS} />
        </div>

        <div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-5 sm:mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0" style={{ background: 'rgba(71,202,241,0.1)', border: '1px solid rgba(71,202,241,0.2)' }}>
              <i className="ri-shield-check-line text-[#47CAF1] text-base"></i>
            </div>
            <div>
              <h2 className="text-lg sm:text-xl font-bold text-white">License &amp; Certificates</h2>
              <div className="glow-line w-24 mt-1"></div>
            </div>
          </div>
          <LogoRow logos={CERT_LOGOS} />
        </div>
      </div>
    </section>
  );
}
